export default [
  {
    title: 'Kezdőlap',
    icon: 'HomeIcon',
    tagVariant: 'light-success',
    route: 'monolit.dashboard',
    roles: 'dashboard',
  },
  {
    title: 'Feladatok',
    icon: 'BriefcaseIcon',
    tagVariant: 'light-success',
    route: 'monolit.global.todo',
    roles: 'todo',
  },
  {
    title: 'Kira',
    icon: 'MessageCircleIcon',
    tagVariant: 'light-primary',
    route: 'monolit.kira.chat',
    roles: 'dashboard',
  },
  {
    title: 'Szabadságok',
    icon: 'StarIcon',
    tagVariant: 'light-success',
    route: 'monolit.freedays.list',
    roles: 'freeday_menu',
  },
  {
    title: 'Munkaszüneti napok',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
    route: 'monolit.workdays.calendar',
    roles: 'workday_calendar',
  },
  {
    title: 'Jelenléti ívek',
    icon: 'DollarSignIcon',
    tagVariant: 'light-success',
    route: 'monolit.accounting.year',
    roles: 'accounting',
  },
  {
    title: 'Létszám menedzsment',
    icon: 'UsersIcon',
    tagVariant: 'light-success',
    route: 'monolit.accounting.workforce-planning',
    roles: 'accounting',
  },
  {
    title: 'IFC betöltő',
    icon: 'BoxIcon',
    tagVariant: 'light-info',
    route: 'monolit.accounting.bim-ifc-import',
    roles: 'accounting',
  },
  {
    title: 'Alkalmazottak',
    icon: 'UsersIcon',
    tagVariant: 'light-success',
    route: 'monolit.employee.list',
    roles: 'employee_menu',
  },
  {
    title: 'Géppark',
    icon: 'TruckIcon',
    tagVariant: 'light-info',
    roles: 'car_menu',
    children: [
      {
        title: 'Járművek',
        route: 'monolit.car.list',
        roles: 'car_menu',
      },
      {
        title: 'Emelő gépek',
        route: 'monolit.lifting-machine.list',
        roles: 'car_menu',
      },
      {
        title: 'Munka gépek',
        route: 'monolit.work-machine.list',
        roles: 'car_menu',
      },
      {
        title: 'Torony daruk',
        route: 'monolit.tower-crane.list',
        roles: 'car_menu',
      },
      {
        title: 'Aggregátor',
        route: 'monolit.aggregator.list',
        roles: 'car_menu',
      },
      {
        title: 'Km/ l kontroling',
        route: 'monolit.km-l-controlling.dashboard',
        roles: 'car_menu',
      },
      {
        title: 'Tankolás import',
        itemClass: 'km-import-item',
        route: 'monolit.km-l-controlling.list',
        roles: 'car_menu',
      },
    ],
  },
  {
    title: 'Hitelezés',
    icon: 'BookIcon',
    tagVariant: 'light-success',
    route: 'monolit.credit.list',
    roles: 'credit_menu',
  },
  {
    title: 'Levonások',
    icon: 'DollarSignIcon',
    tagVariant: 'light-success',
    roles: 'private_comment',
    route: 'monolit.private_comment.list',
  },
  {
    title: 'Számlák',
    icon: 'FileTextIcon',
    tagVariant: 'light-success',
    roles: 'invoice_progress',
    route: 'monolit.invoice.list',
  },
  {
    title: 'Alvállakozók',
    icon: 'UsersIcon',
    tagVariant: 'light-success',
    roles: 'subcontractor',
    route: 'monolit.subcontractor.list',
  },
  {
    title: 'Projektek',
    icon: 'BriefcaseIcon',
    tagVariant: 'light-success',
    roles: 'project',
    route: 'monolit.projects.list',
  },
  {
    title: 'Pótmunka rögzítése',
    icon: 'PlusIcon',
    tagVariant: 'light-success',
    roles: 'additional_work_create',
    route: 'monolit.projects.additional_work_create',
  },
  {
    title: 'Ajánlati lista',
    icon: 'BriefcaseIcon',
    tagVariant: 'light-success',
    roles: 'project',
    route: 'monolit.project.total.offers',
  },
  {
    title: 'Tankolás',
    icon: 'DropletIcon',
    tagVariant: 'light-info',
    roles: ['tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin'],
    children: [
      {
        title: 'Tankolás rögzítés',
        route: 'monolit.tankolas.record',
        roles: ['tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Tartály feltöltés',
        route: 'monolit.tankolas.refill',
        roles: ['tankolas_role_tankolo', 'tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Gépek',
        route: 'monolit.tankolas.machines',
        roles: ['tankolas_role_halado', 'tankolas_role_admin'],
      },
      {
        title: 'Gépkezelők',
        route: 'monolit.tankolas.operators',
        roles: ['tankolas_role_halado', 'tankolas_role_admin'],
      },
    ],
  },
  {
    title: 'Riportok',
    icon: 'BarChartIcon',
    tagVariant: 'light-success',
    roles: 'report',
    route: 'monolit.report.list',
  },
  {
    title: 'Kontrolling',
    icon: 'TrendingUpIcon',
    tagVariant: 'light-warning',
    roles: 'report',
    route: 'monolit.controlling.dashboard',
  },
  {
    title: 'Rendelések',
    icon: 'BoxIcon',
    tagVariant: 'light-info',
    roles: 'order_menu',
    children: [
      {
        title: 'Rendeléseim',
        route: 'monolit.order.own',
        roles: 'create_order',

      },
      {
        title: 'Létrehozás',
        route: 'monolit.order.create',
        roles: 'create_order',
      },
      {
        title: 'Rendelések',
        route: 'monolit.order.list.list',
        roles: 'progress_order',
      },
      {
        title: 'Számlák',
        route: 'monolit.order.invoice.list',
        roles: 'invoices_offer',
      },
    ],
  },
  {
    title: 'Előkészítés',
    icon: 'ClipboardIcon',
    tagVariant: 'light-info',
    roles: ['prep_view_all', 'prep_assign_project', 'prep_view_own'],
    route: 'monolit.preparation.list',
  },
  {
    title: 'Felhasználók',
    icon: 'UserIcon',
    tagVariant: 'light-info',
    roles: 'user',
    route: 'monolit.user.list',
  },
  {
    title: 'Viber beállítások',
    icon: 'SendIcon',
    tagVariant: 'light-success',
    roles: 'viber',
    route: 'monolit.viber.settings',
  },
  {
    title: 'Extra mezők',
    icon: 'SettingsIcon',
    tagVariant: 'light-success',
    route: 'monolit.extrafields.list',
    roles: 'extra_fields',
  },
]
